import React, { useState } from "react";
import { Button, Card, Modal } from "react-bootstrap";
import { SiNestjs, SiMysql, SiFlutter, SiBootstrap, SiReact, SiHtml5, SiCss3, SiFirebase, SiFlask, SiNumpy, SiPython, SiPytorch, SiKotlin, SiJetpackcompose, SiTensorflow, SiDart, SiNodedotjs, SiExpress, SiMongodb, SiNginx, SiAmazonaws, SiAngular, SiIonic, SiGoogleplay, SiAppstore, SiJavascript, SiGit, SiRuby, SiRubyonrails, SiHeroku, SiD3Dotjs, SiDjango, SiTailwindcss, SiNetlify, SiAdobeillustrator, SiAdobeindesign, SiAdobephotoshop, SiBlender, SiOpenjdk, SiSpring, SiSpringboot, SiElasticsearch } from "react-icons/si";
import { FaJava } from "react-icons/fa";
import styles from "./ExperienceCard.module.css";


const icons = {
  AdobeIllustrator: <SiAdobeillustrator className={styles.icon} style={{ color: "#FF9A00" }} />,
  AdobeIndesign: <SiAdobeindesign className={styles.icon} style={{ color: "#FF3366" }} />,
  AdobePhotoshop: <SiAdobephotoshop className={styles.icon} style={{ color: "#31A8FF" }} />,
  AppleAppStore: <SiAppstore className={styles.icon} style={{ color: "#0D96F6" }} />,
  Angular: <SiAngular className={styles.icon} style={{ color: "#0F0F11" }} />,
  AWS: <SiAmazonaws className={styles.icon} style={{ color: "#232F3E" }} />,
  Blender: <SiBlender className={styles.icon} style={{ color: "#F5792A" }} />,
  Bootstrap: (
    <SiBootstrap className={styles.icon} style={{ color: "#7952B3" }} />
  ),
  CSS: <SiCss3 className={styles.icon} style={{ color: "#1572B6" }} />,
  D3dotjs: <SiD3Dotjs className={styles.icon} style={{ color: "#F9A03C" }} />,
  Dart: <SiDart className={styles.icon} style={{ color: "#0175C2" }} />,
  Django: <SiDjango className={styles.icon} style={{ color: "#092E20" }} />,
  Express: <SiExpress className={styles.icon} style={{ color: "#000000" }} />,
  Firebase: (
    <SiFirebase className={styles.icon} style={{ color: "#FFCA28" }} />
  ),
  Flask: (
    <SiFlask className={styles.icon} style={{ color: "#000000" }} />
  ),
  Flutter: (
    <SiFlutter className={styles.icon} style={{ color: "#02569B" }} />
  ),
  Git: <SiGit className={styles.icon} style={{ color: "#F05032" }} />,
  GooglePlay: <SiGoogleplay className={styles.icon} style={{ color: "#414141" }} />,
  Heroku: <SiHeroku className={styles.icon} style={{ color: "#430098" }} />,
  HTML: <SiHtml5 className={styles.icon} style={{ color: "#E34F26" }} />,
  Ionic: <SiIonic className={styles.icon} style={{ color: "#3880FF" }} />,
  // @@ AI-COMMENT: Multiple Java icon options - choose the one you prefer
  Java: <FaJava className={styles.icon} style={{ color: "#ED8B00" }} />,
  JavaScript: <SiJavascript className={styles.icon} style={{ color: "#F7DF1E" }} />,
  JetpackCompose: <SiJetpackcompose className={styles.icon} style={{ color: "#4285F4" }} />,
  Kotlin: <SiKotlin className={styles.icon} style={{ color: "#7F52FF" }} />,
  Tensorflow: <SiTensorflow className={styles.icon} style={{ color: "#FF6F00" }} />,
  MongoDB: <SiMongodb className={styles.icon} style={{ color: "#47A248" }} />,
  MySQL: <SiMysql className={styles.icon} style={{ color: "#4479A1" }} />,
  NestJS: <SiNestjs className={styles.icon} style={{ color: "#E0234E" }} />,
  Netlify: <SiNetlify className={styles.icon} style={{ color: "#00C7B7" }} />,
  Nginx: <SiNginx className={styles.icon} style={{ color: "#009639" }} />,
  Nodedotjs: <SiNodedotjs className={styles.icon} style={{ color: "#339933" }} />,
  NumPy: <SiNumpy className={styles.icon} style={{ color: "#013243" }} />,
  Python: <SiPython className={styles.icon} style={{ color: "#3776AB" }} />,
  PyTorch: <SiPytorch className={styles.icon} style={{ color: "#EE4C2C" }} />,
  React: <SiReact className={styles.icon} style={{ color: "#61DAFB" }} />,
  Ruby: <SiRuby className={styles.icon} style={{ color: "#CC342D" }} />,
  RubyOnRails: <SiRubyonrails className={styles.icon} style={{ color: "#D30001" }} />,
  Spring: <SiSpring className={styles.icon} style={{ color: "#6DB33F" }} />,
  SpringBoot: <SiSpringboot className={styles.icon} style={{ color: "#6DB33F" }} />,
  Elasticsearch: <SiElasticsearch className={styles.icon} style={{ color: "#6DB33F" }} />,
  TailwindCSS: <SiTailwindcss className={styles.icon} style={{ color: "#38B2AC" }} />,
};

const ExperienceCard = (props) => {
  const [modalDisplay, setModalDisplay] = useState(false);

  const handleModalOpen = () => setModalDisplay(true);
  const handleModalClose = () => setModalDisplay(false);

  // Map shadow colors
  const shadowClass = props.colorVariant === "yellow" ? styles.shadowYellow : 
                     props.colorVariant === "purple" ? styles.shadowPurple : 
                     props.colorVariant === "cyan" ? styles.shadowCyan : "";

  return (
    <Card className={`${styles.container} ${shadowClass}`}>
      <Card.Body className={styles.cardBody}>
        <div className={styles.organization}>{props.organization}</div>
        <Card.Title className={styles.cardTitle}>{props.title}</Card.Title>
        <span className={styles.duration}>{props.duration}</span>

        <div className={styles.techStackContainer}>
          {props.techStack?.map((tech, index) => (
             <span key={index} title={tech}>{icons[tech]}</span>
          ))}
        </div>

        <div className={styles.buttonContainer}>
          {props.liveUrl && (
            <Button
              className={styles.button}
              href={props.liveUrl}
              target="_blank"
            >
              Visit Website
            </Button>
          )}
          {props.description && (
            <Button
              className={`${styles.button} ${styles.buttonViewDesc}`}
              onClick={handleModalOpen}
            >
              View Description
            </Button>
          )}
        </div>

        {props.description && (
          <Modal
            centered
            size="lg"
            show={modalDisplay}
            onHide={handleModalClose}
            contentClassName="neubrutalist-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ fontWeight: 900 }}>{props.organization}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '2rem' }}>
              <h4 className={styles.modalBodyTitle}>{props.title}</h4>
              <h5 className={styles.duration}>{props.duration}</h5>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
                {props.techStack?.map((tech, index) => (
                  <span key={index} className={styles.icon}>{icons[tech]}</span>
                ))}
              </div>
              <ul className={styles.descriptionList}>
                {props.description.map((elem, i) => (
                  <li key={i}>{elem}</li>
                ))}
              </ul>
            </Modal.Body>
          </Modal>
        )}
      </Card.Body>
    </Card>
  );
};

export default ExperienceCard;
